export default __webpack_public_path__ + "static/media/Studio.b29a0522.png";